module.exports = __webpack_public_path__ + "static/media/vertical.08303543.png";